<template>
  <div class="customer">
    <label :for="'autocomplete' + tripNumber">Customer: </label>
    <!-- Reemplazo de PrimeVue por Element UI el-autocomplete -->
    <el-autocomplete
      v-model="customerName"
      :fetch-suggestions="querySearch"
      :id="'autocomplete' + tripNumber"
      :title="selectedCustomer ? selectedCustomer.name : 'Not selected customer'"
      placeholder="Search..."
      @select="handleSelect"
      popper-class="customer-autocomplete-popper"
      style="width: 70%"
      clearable
    >
      <template slot-scope="{ item }">
        <div class="customer-item">
          <span>{{ item.name }}</span>
        </div>
      </template>
    </el-autocomplete>
    <br />
    <span v-if="thereIsCustomers" class="not-found">Customer not found.</span>
    <div v-if="selectedCustomer" class="customer__props">
      <div class="customer__props-type">
        <p>
          <strong>Customer Type: </strong>
          {{
            customerType === "" || customerType === null
              ? "Empty"
              : customerType
          }}
        </p>
      </div>
      <b-badge
        v-if="isNewCustomer"
        class="customer__props-tag"
        variant="success"
        pill
      >
        New Customer
      </b-badge>
    </div>
  </div>
</template>

<script>
import { removePointerEvents } from "@/mixins/pickupAndDelivery/standardizers";

export default {
  name: "Customer",
  props: {
    tripNumber: Number
  },
  data() {
    return {
      thereIsCustomers: false,
      selectedCustomer: null,
      customerType: null,
      isNewCustomer: false,
      filteredCustomers: [],
      customerName: "",
      haulInformation: null,
      allowed: true,
      user: null,
      firstTripId: null,
      item: null,
      assignedUser: null,
      disableEmailResponse: true,
      scrollListener: null,
      scrollTimer: null,
      skip: 0,
      currentQuery: "",
      isLoadingMore: false,
      hasMoreCustomers: true
    };
  },
  watch: {
    selectedCustomer(newVal) {
      if (!newVal) {
        setTimeout(() => {
          this.thereIsCustomers = false;
          this.customerType = null;
          this.isNewCustomer = false;
        }, 700);
      } else {
        this.customerType = newVal.customer_type;
        this.isNewCustomer = newVal.new_customer;
        this.customerName = newVal.name;
      }
    },
    customerName(val) {
      if (!val) {
        this.selectedCustomer = null;
      }
    }
  },
  async created() {
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    let accountId = this.haulInformation[this.tripNumber - 1].customer_id;

    if (accountId != null) {
      let response = await this.$store.dispatch(
        "quotes/quote/getCustomersById",
        accountId
      );
      if (response.data && response.data.length > 0) {
        this.selectedCustomer = response.data[0];
      }
    }
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    this.handlerCustomer();
    this.attachScrollObserver();
  },
  beforeDestroy() {
    this.removeScrollObserver();
  },
  methods: {
    async querySearch(queryString, cb) {
      if (queryString) {
        this.currentQuery = queryString;
        this.skip = 0;
        this.hasMoreCustomers = true;
        this.thereIsCustomers = false;
        let response = await this.$store.dispatch(
          "quotes/quote/getDataCustomers",
          { customer: queryString, skip: this.skip }
        );
        this.filteredCustomers = response.data || [];
        this.thereIsCustomers = this.filteredCustomers.length === 0;
        this.hasMoreCustomers = response.data && response.data.length > 0;
        cb(this.filteredCustomers);
      } else {
        this.thereIsCustomers = false;
        this.hasMoreCustomers = true;
        this.skip = 0;
        this.currentQuery = "";
        cb([]);
      }
    },
    handleSelect(item) {
      this.selectedCustomer = item;
      this.updateCustomer({ value: item });
    },
    attachScrollObserver() {
      this.scrollTimer = setInterval(() => {
        const popper = document.querySelector(
          ".customer-autocomplete-popper .el-autocomplete-suggestion__wrap"
        );
        if (popper && !this.scrollListener) {
          this.scrollListener = async (event) => {
            const element = event.target;
            if (
              element.scrollHeight - element.scrollTop <=
              element.clientHeight + 1
            ) {
              if (
                this.hasMoreCustomers &&
                !this.isLoadingMore &&
                this.currentQuery
              ) {
                this.isLoadingMore = true;
                this.skip += 10;
                let response = await this.$store.dispatch(
                  "quotes/quote/getDataCustomers",
                  { customer: this.currentQuery, skip: this.skip }
                );
                const newCustomers = response.data || [];
                if (newCustomers.length > 0) {
                  this.filteredCustomers = [...this.filteredCustomers, ...newCustomers];
                  const autocomplete = this.$el.querySelector(".el-autocomplete");
                  if (autocomplete && autocomplete.__vue__) {
                    autocomplete.__vue__.suggestions = this.filteredCustomers;
                  }
                } else {
                  this.hasMoreCustomers = false;
                }
                this.isLoadingMore = false;
              }
            }
          };
          popper.addEventListener("scroll", this.scrollListener);
        }
      }, 500);
    },

    removeScrollObserver() {
      clearInterval(this.scrollTimer);
      const popper = document.querySelector(
        ".customer-autocomplete-popper .el-autocomplete-suggestion__wrap"
      );
      if (popper && this.scrollListener) {
        popper.removeEventListener("scroll", this.scrollListener);
        this.scrollListener = null;
      }
    },

    handlerCustomer() {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      let currentDepartment = JSON.parse(
        localStorage.getItem("current-department")
      );
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (currentDepartment.department_id == 1 &&
          currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (this.allowed) {
        if (
          (currentDepartment.rol_name == "quoter" &&
            this.$route.params.pathName == "queue") ||
          this.disableEmailResponse ||
          this.item.message.validation_alert
        ) {
          removePointerEvents("autocomplete" + this.tripNumber);
        }
      } else {
        removePointerEvents("autocomplete" + this.tripNumber);
      }
    },
    async updateCustomer(event) {
      this.haulInformation = this.$store.getters[
        "quotes/quote/showQuoteById"
      ].haul;
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      info.payload.customer_id = event.value.id;
      this.$store.dispatch("quotes/haul/updateHaul", info);

      if (this.haulInformation.length !== 1) {
        if (this.tripNumber === 1) {
          this.firstTripId = event.value.id;
          for (let i = 1; i < this.haulInformation.length; i++) {
            let info = {};
            info.haulId = this.haulInformation[i].id;
            info.payload = {};
            info.payload.customer_id = this.firstTripId;
            this.$store.dispatch("quotes/haul/updateHaul", info);
            await this.$store.dispatch(
              "quotes/quote/getCustomersById",
              this.firstTripId
            );
          }
          this.$emit("reloadCustomer");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.customer {
  position: relative;
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  label {
    margin: 0;
    margin-right: 15px;
  }
  &__props {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    width: calc(70% + 90px);
    margin: 5px auto 0;
    text-align: left;
    &-type {
      margin-inline-start: 90px;
      p {
        margin: 0;
      }
    }
    &-tag {
      margin-inline-start: 10px;
      padding: 5px 15px;
      color: $color-user-active;
      background-color: #0be81231;
    }
  }
}

.not-found {
  position: absolute;
  bottom: -20px;
  left: 142px;
  width: 50%;
  font-size: 11px;
  align-self: center;
  text-align: left;
  color: red;
}

::v-deep .el-input__inner {
  width: 100% !important;
  padding: 3px 10px;
  background: $color-background-input;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  &:hover {
    @include box-shadow;
    border-color: get-opacity($color-gray-shadow, 30%) !important;
  }
  &:focus {
    border-color: get-opacity($color-gray-shadow, 80%) !important;
    box-shadow: 0 0 0 0.2rem get-opacity($color-gray-shadow, 40%) !important;
  }
}

.customer-item {
  text-align: left;
  font-size: 14px;
}

::v-deep .el-popper {
  width: auto !important;
}

::v-deep .el-scrollbar {
  width: auto !important;
}

::v-deep .el-input__suffix {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

@media (max-width: 604px) {
  .not-found {
    margin-top: 7px;
  }
}
</style>
